import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Loading from "../loading";
import Snackbar from "../snackbar";
import Logo from "../logoWithText";
import ChangeLanguage from "../changeLanguage";
import { styles } from "./styles";
import { version } from "../../utils/setting";
class PickerBranch extends Component {
  constructor(props) {
    super();
    this.state = {
      options: props.options,
    };
  }
  _parseRole = (role) => {
    if (role === "ownerSpa") {
      return "owner";
    } else if (role === "employeeSpa" || role === "employeeAdmin") {
      return "employee";
    } else return role;
  };
  componentDidMount() {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.roles &&
      this.props.location.state.user
    ) {
      let roles =
        this.props.location && this.props.location.state
          ? this.props.location.state.roles
          : [];
    } else {
      this.props.history.push("/signin");
    }
  }

  async handleClick(value) {
    let { t } = this.props;
    this.loading.startLoading();
    let { user } = this.props.location.state;
    let res = await this.props.login({ user: user, role: value });
    if (res.code === 1) {
      const data = res.dataUser;
      if (
        data.roleId &&
        (data.roleId.role === "ownerSpa" || data.roleId.role === "employeeSpa")
      ) {
        this.props.history.push("/");
      } else if (
        data.roleId &&
        (data.roleId.role === "admin" || data.roleId.role === "employeeAdmin")
      ) {
        this.props.history.push("/");
      }
    } else if (res.error === 1003 || res.error === 1005) {
      this.snackbar(
        t("Login_phone_number_and_password_combination_is_incorrect"),
        "error"
      );
    } else if (res.error === 1105) {
      this.snackbar(t("Login_error_access_account"), "error");
    } else if (res.error === 1166) {
      this.snackbar(t("Login_error_package_expired"), "error");
    } else if (res.error === 1175) {
      this.snackbar(t("Employee not access"), "error");
    } else if (res.error === 1187) {
      this.snackbar(t("Login_user_inactive"), "error");
    } else if (res.error === 1108) {
      this.snackbar(t("Login_your_account_inactive_or_deleted"), "error");
    } else if (res.error === 1013) {
      this.snackbar(t("Login_your_service_deleted"), "error");
    } else this.snackbar(res.message, "error");
    this.loading.stopLoading();
  }
  snackbar = (message, type = "success") => {
    this.mSnackbar.handleClick(message, type);
  };

  render() {
    const { t, classes, ...other } = this.props;
    let roles =
      this.props.location && this.props.location.state
        ? this.props.location.state.roles
        : [];
    roles = roles.filter((e) => e.role !== "user");
    if (!roles.length) this.props.history.push("/signin");
    return (
      <div className="login-wrapper login-role-wapper">
        <ChangeLanguage />
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <div className="login-container">
          <div
            className={classes.logo}
            onClick={() => this.props.history.push("/")}
          >
            <Logo />
          </div>
          <Typography className={classes.title}>
            {t("choose_your_work_place")}
          </Typography>
          {roles.length ? (
            <div class="list-role">
              {roles.map((role) => {
                return (
                  <div class="one-role" onClick={() => this.handleClick(role)}>
                    <div class="name-spa">
                      {role.spaName ? role.spaName : "MASSPA"}{" "}
                      {role.role === "admin" ? (
                        <img
                          className={classes.adminRole}
                          src={require("../../images/crown.svg")}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div class="name-role">{this._parseRole(role.role)}</div>
                    <div class="line"></div>
                  </div>
                );
              })}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="bottom-version">v {version}</div>
      </div>
    );
  }
}

PickerBranch.propTypes = {
  classes: PropTypes.object.isRequired,
  // theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  login: dispatch.user.login,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(PickerBranch)));
